module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "table-search",
    attrs: {
      "type": "search",
      "placeholder": "Search in resources..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }, function($event) {
        return _vm.mainSearch(1, 20)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  }, [_c('icon', {
    attrs: {
      "name": "search"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fb519e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/newCmsStyle/ComponentArticle/searchInArticles.vue
// module id = 952
// module chunks = 0